import { render, staticRenderFns } from "./NewClients.vue?vue&type=template&id=066721b6"
import script from "./NewClients.vue?vue&type=script&lang=js"
export * from "./NewClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports